import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const MultipleChoiceBlockV2 = ({
  selected,
  onSelect,
  disabled = false,
  children,
  className,
}: {
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "p-4 border rounded-xl flex items-center gap-4 flex-1 transition-all duration-150 text-md font-semibold text-gray-v2-900",
        selected
          ? "bg-brand-v2-50 border-brand-v2-300"
          : "bg-white border-gray-v2-200",
        disabled ? "select-none" : "cursor-pointer",
        className
      )}
      onClick={disabled ? undefined : onSelect}
    >
      {children}
    </div>
  );
};
